// extracted by mini-css-extract-plugin
export default {"imageContainer":"x0-z","summaryPar":"y0-z","ratingCategories":"z0-z","reviewerInfo":"A0-z","reviewTypes":"B0-z","expanded":"C0-z"};